(function () {
    'use strict';

    var FILTER_FACTORY = 'FilterFactory';

    angular
        .module('sodCommon')
        .factory(FILTER_FACTORY, FilterFactory);

    function FilterFactory(lodash, $rootScope) {
        var filters = {};

        function get(pathType, activeFilters) {
            handleActiveFilters(pathType, activeFilters);
            return lodash.get(filters, pathType, []);
        }

        function set(pathType, filtersToSet, skipEmit) {
            var initialFilters = Object.assign({}, filters);
            lodash.set(filters, pathType, filtersToSet);

            if (!skipEmit) {
                handleEmitChanges(initialFilters, pathType);
            }
            return get(pathType);
        }

        function add(pathType, filter, skipEmit) {
            var initialFilters = Object.assign({}, filters);
            var pathTypeFilters = lodash.get(filters, pathType, []);
            var pathTypeFiltersAdded = lodash.concat(pathTypeFilters, filter);

            set(pathType, lodash.uniq(pathTypeFiltersAdded));
            if (!skipEmit) {
                handleEmitChanges(initialFilters, pathType);
            }
            return get(pathType);
        }

        function handleEmitChanges(initialFilters, pathType) {
            var pathTypes = pathType.split('.');
            if (pathTypes.length >= 2) {
                emitChanges(pathType);
                emitChanges(pathTypes[0]);
            } else {
                lodash.forEach(lodash.keys(initialFilters[pathTypes[0]]), function (initialFilterKey) {
                    emitChanges([pathTypes[0], initialFilterKey].join('.'));
                });
                emitChanges(pathTypes[0]);
            }
        }

        function handleActiveFilters(pathType, activeFilters) {
            var pathTypes = pathType.split('.');
            if (!lodash.isEmpty(pathTypes) && pathTypes.length >= 2) {
                var filterTypeKey = pathTypes[1];
                var foundActiveApplied = lodash.find(lodash.get(activeFilters, 'applied', []), { field: filterTypeKey });
                var foundActiveSearch = lodash.find(lodash.get(activeFilters, 'search', []), { field: filterTypeKey });
                var foundActiveFilter = foundActiveApplied || foundActiveSearch;

                if (foundActiveFilter) {
                    var value = lodash.get(foundActiveFilter, 'value');
                    add(pathType, value, true);
                    $rootScope.$broadcast([FILTER_FACTORY, pathTypes[0], 'reload'].join('.'));
                    emitChanges([pathType, 'addDisplayOptions'].join('.'))
                }
            }
        }

        function emitChanges(pathType) {
            $rootScope.$broadcast([FILTER_FACTORY, pathType].join('.'), get(pathType));
        }

        return {
            get: get,
            set: set,
            add: add,
            eventPrefix: FILTER_FACTORY,
        };
    }
})();